import { IonButton, IonItem, IonLabel, IonList, IonToast } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import './DeleteAccountModal.scoped.scss';
import React, { useState } from 'react';
import { useDeleteAccountMutation } from '../../store/api';

const DeleteAccountModal = ({
  onDismiss,
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void;
}) => {
  const { t } = useTranslation();
  const [deleteAccount] = useDeleteAccountMutation();
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const onSubmit = async (data: any) => {
    try {
      const deleteAccountResult = await deleteAccount().unwrap();

      if (deleteAccountResult) {
        onDismiss(null, 'confirm');
      }
    } catch (e: any) {
      const errorsMessage = Object.values(e?.data?.errors).join('\n');
      setErrorMessage(true);
      setToastMessage(errorsMessage);
      setShowToast(true);
    }
  };
  return (
    <div className="modal-wrapper">
      <IonList className="modal-items">
        <IonItem lines="none" color="none" className="ion-padding-bottom ion-no-margin">
          <IonLabel className="modal-title">
            {t('Are you sure you want to delete your account?')}
          </IonLabel>
        </IonItem>

        <div className="buttons-wrap">
          <IonButton
            className="primary-type-button-small"
            onClick={() => onDismiss(null, 'cancel')}
          >
            {t('Cancel')}
          </IonButton>
          <IonButton className="primary-type-button-small submit-btn" onClick={onSubmit}>
            {t('Delete')}
          </IonButton>
        </div>
      </IonList>
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={toastMessage}
        duration={5000}
        color={errorMessage ? 'danger' : 'success'}
      />
    </div>
  );
};

export default DeleteAccountModal;
